import { Box, SxProps } from "@mui/material"
import { GridColDef } from "@mui/x-data-grid"
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { DateTime } from "luxon";
import styles from './PropertySpyItemDetailChangeListTable.module.css'

interface PropertySpyItemDetailChangeListTableProps {
    data?: any[]
}

export const PropertySpyItemDetailChangeListTable = (props: PropertySpyItemDetailChangeListTableProps): JSX.Element => {
    const {
        data
    } = props

    const gridRoot: SxProps = {
        display: 'inline-grid',
        gridTemplateColumns: '70px 110px 120px max-content',
        gap: '20px',
        rowGap: '20px',
        columnGap: '10px',
        padding: '6px',
        borderRadius: `4px`,
        border: `1px solid rgba(0, 0, 0, 0.12)`,
        maxHeight: '300px',
        overflow: 'auto',
        maxWidth: '100%'
    }

    const headingStyle: SxProps = {
        fontSize: '24px',
        fontWeight: 600
    }

    const gridHeaderCellStyle: SxProps = {
        fontSize: '20px',
        fontWeight: 600,
        margin: '0 20px 0 0',
        display: 'flex',
        alignItems: 'center', 
        minWidth: '70px'
    }

    const gridValueCellStyle: SxProps = {
        fontSize: '20px',
        display: 'flex',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    }

    const getPropTitle = (propertyName: string): string => {
        if (propertyName.toLowerCase().indexOf('price') > -1) {
            return `Price`
        }

        return propertyName
    }


    const getPropOldValue = (value: string): string => {
        return value
    }

    const getValuePrefix = (propertyName: string): string => {
        if (propertyName.toLowerCase().indexOf('price') > -1) {
            return `$`
        }

        return ``
    }

    const getNewValueDirection = (oldValue: string, newValue: string): JSX.Element => {
        try {
            const oldValueInt = parseInt(oldValue)
            const newValueInt = parseInt(newValue)

            if (newValueInt > oldValueInt) {
                return (<ArrowUpwardIcon color="success"></ArrowUpwardIcon>)
            }

            if (newValueInt < oldValueInt) {
                return (<ArrowDownwardIcon color="success"></ArrowDownwardIcon>)
            }

            return (<Box sx={{
                width: '24px'
            }}></Box>)

        } catch (e) {
            return (<></>)
        }
    }

    const getFullNewValueDirection = (row: any): JSX.Element => {
        if (row.newValue === undefined || row.newValue === ``) {
            return (
                <>N/A</>
            )
        }


        const valueDirection = getNewValueDirection(row.oldValue, row.newValue)
        const prefix = getValuePrefix(row.propName)

        return (
            <>
                {valueDirection}
                {prefix}
                {row.newValue}
            </>
        )
    }

    const getFullPrevValue = (row: any): JSX.Element => {
        const prefix = getValuePrefix(row.propName)

        if (row.oldValue === undefined || row.oldValue === ``) {
            return (
                <>N/A</>
            )
        }

        return (
            <>
                {prefix}
                {row.oldValue}
            </>
        )
    }

    const renderValueList = () => {
        if (data === undefined) {
            return (<></>)
        } 

        return data.map((row, index) => {
            return (
                <>
                    <Box key={Math.random()} sx={gridValueCellStyle}>{getPropTitle(row.propName)}:</Box>
                    <Box key={Math.random()} sx={gridValueCellStyle}>{getFullPrevValue(row)}</Box>
                    <Box key={Math.random()} sx={gridValueCellStyle}>{getFullNewValueDirection(row)}</Box>
                    <Box key={Math.random()} sx={gridValueCellStyle}>{DateTime.fromISO(row.checkinUtc).toFormat('M/dd/yyyy')}</Box>
                </>
            )
        })
    }

    return (
        <div className={styles.PropertySpyItemDetailChangeListTable}>
            <Box key="changes" sx={headingStyle}>Changes:</Box>
            <Box
                key="gridRoot"
                sx={gridRoot}
            >
                <Box key="value" sx={gridHeaderCellStyle}></Box>
                <Box key="previous" sx={gridHeaderCellStyle}>Previous</Box>
                <Box key="current" sx={gridHeaderCellStyle}>Current</Box>

                <Box key="current" sx={gridHeaderCellStyle}>Time period</Box>              
                {renderValueList() }
            </Box>
        </div>
    )
}